import { memo } from "react";

export const CountryFlag = memo(
  ({
    countryCode,
    getFlag,
  }: {
    countryCode: string;
    getFlag: (name: string) => string | undefined;
  }) => {
    // I'd use directly `getFlag` since it return string | undefined, but I'm not sure I get
    // its implementation and side-effects
    const src = getFlag(countryCode) || undefined;

    return <img aria-hidden alt="" className="flag" src={src} />;
  }
);
CountryFlag.displayName = "CountryFlag";
